<template>
  <v-layout
    wrap
    justify-center
  >
    <v-flex
      xs4
    >
      <v-btn
        block
        style="height:calc(30vh);margin-top:20px;"
        @click="move('down')"
      >
        atras
      </v-btn>
    </v-flex>
    <v-flex
      xs4
    >
    <center><span style="font-size: calc(30vh)"> {{position}} </span></center>
    </v-flex>
    <v-flex
      xs4
    >
    <v-btn
      block
      style="height:calc(30vh);margin-top:20px;"
      @click="move('up')"
    >
      siguiente
    </v-btn>
    </v-flex>
    <v-flex
      xs12
    >
      <v-btn
        block
        @click="move('reset')"
      >
        reset
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import io from "socket.io-client"
export default {
  name: 'Player',
  props: {
  },
  data () {
    return {
      position: null,
    }
  },
  created() {
    // this.socket = io("http://localhost:3300");
    this.socket = io("https://qmanager.dviewcontent.com");
  },
  mounted () {
      this.socket.on("position", data => {
        this.position = data
        // console.log(data)
    })
  },
  methods: {
    move(direction) { this.socket.emit("move", direction); },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
